/**
 * Solo Grind state map factory.
 *
 * Single-player, house-banked Hi-Lo / Chuck-a-Luck. Short purpose-built
 * states (they call the same SDLGame subsystems the craps states do) rather
 * than reusing the craps states, which carry point/shooter-rotation branches
 * solo has no use for.
 *
 * Flow: WAITING → BETTING → FADE → ROLL → BETTING (loop)
 * Hi-Lo 7 continue: ROLL → REROLL → ROLL (transparent beat, bet stays live,
 * dice stay on the floor — mirrors craps POINT_RESULT).
 */

import { SoloState } from '@sdl/shared';
import { State } from '../State.js';
import type { StateMachine } from '../StateMachine.js';
import type { SDLGame } from '../SDLGame.js';
import { SoloWaitingState } from '../states/SoloWaitingState.js';
import { SoloBettingState } from '../states/SoloBettingState.js';
import { SoloFadeState } from '../states/SoloFadeState.js';
import { SoloRollState } from '../states/SoloRollState.js';

export function buildSoloStates(
  sm: StateMachine,
  game: SDLGame,
): Map<string, State> {
  const states = new Map<string, State>();
  states.set(SoloState.WAITING, new SoloWaitingState(sm, game));
  states.set(SoloState.BETTING, new SoloBettingState(sm, game));
  states.set(SoloState.FADE, new SoloFadeState(sm, game));
  states.set(SoloState.ROLL, new SoloRollState(sm, game));
  states.set(SoloState.REROLL, new State(sm, game)); // pure transitional (craps POINT_RESULT twin)
  states.set(SoloState.GAME_END, new State(sm, game)); // noop terminal
  return states;
}
